import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CartOfferedGift,
  CartProduct,
  CartSpecialOffer,
  CartOfferType,
} from 'types/Cart';

export default function useCheckoutSummaryList(
  products: CartProduct[],
  gifts?: CartOfferedGift[],
  specialOffers?: CartSpecialOffer[]
): UseCheckoutSummaryListType {
  const { t } = useTranslation();

  const availableGifts = useMemo(
    () => gifts && formatProducts(gifts, t('LABEL_YOUR_FREE_GIFT')),
    [gifts]
  );
  const availableSpecialOffers = useMemo(
    () =>
      specialOffers &&
      formatProducts(specialOffers, t('LABEL_YOUR_SPECIAL_OFFER')),
    [specialOffers]
  );
  const productList = useMemo(() => {
    return [
      ...products,
      ...(availableGifts ?? []),
      ...(availableSpecialOffers ?? []),
    ];
  }, [products, availableGifts, availableSpecialOffers]);

  function formatProducts(
    offers: CartOfferedGift[] | CartSpecialOffer[],
    title: string
  ): CartOfferType[] {
    let availableProducts: CartOfferType[] = [];

    offers?.map((offer: CartOfferedGift | CartSpecialOffer) => {
      const {
        attributes: { isInvisible },
        products,
      } = offer;

      if (isInvisible !== 'O') {
        const formattedProducts = products.map(product => {
          return {
            ...product,
            quantity: 1,
            size: product.sizeLabel,
            title: title,
            totalPrice: product.price,
          };
        });

        availableProducts = [...availableProducts, ...formattedProducts];
      }
    });

    return availableProducts;
  }

  return { productList };
}

type UseCheckoutSummaryListType = {
  productList: (CartProduct | CartOfferType)[];
};
